export const LandingHome = () => {
    return (
        <div className="h-screen w-screen bg-gray-100 flex flex-col items-center justify-center gap-4">
            <h2 className="text-2xl font-bold">👋 Therapprove</h2>
            <p className="text-gray-500 text-balance max-w-[500px] text-center">
                Hi! You might be looking for{" "}
                <a
                    href="https://therapprove.com"
                    className="text-teal-500 underline font-medium"
                >
                    Therapprove.com
                </a>
                . If you landed here do to an error, please{" "}
                <a
                    href="mailto:support@therapprove.com"
                    className="text-teal-500 font-medium underline"
                >
                    Contact Support
                </a>
            </p>
        </div>
    );
};
